export default __webpack_public_path__ + "static/media/glodny.4dd6b6ae.svg";